import React from "react"
import { Field } from "react-final-form"
import Select from "react-select"

export const FileField = ({ name, ...props }) => (
  <Field name={name}>
    {({ input: { value, onChange, ...input } }) => {
      const handleChange = (target) => {
        onChange(target.files);
      }
      return <input {...input} type="file" onChange={handleChange} {...props} />
    }}
  </Field>
)


export const ReactSelectAdapter = ({ input, ...rest }) => (
  <Select {...input} {...rest} searchable />
)